import auteurapi from '../../shared/webapi/auteurapi.js'

export const REQUEST_AUTEURLIVRES = 'REQUEST_AUTEURLIVRES';
export const FETCH_AUTEURLIVRES_SUCCESS = 'FETCH_AUTEURLIVRES_SUCCESS';
export const FETCH_AUTEURLIVRES_FAILURE = 'FETCH_AUTEURLIVRES_FAILURE';

export const REQUEST_BIOBIBLIO = 'REQUEST_BIOBIBLIO';
export const FETCH_BIOBIBLIO_SUCCESS = 'FETCH_BIOBIBLIO_SUCCESS';
export const FETCH_BIOBIBLIO_FAILURE = 'FETCH_BIOBIBLIO_FAILURE';

export const REQUEST_AUTEURLIENS = 'REQUEST_AUTEURLIENS';
export const FETCH_AUTEURLIENS_SUCCESS = 'FETCH_AUTEURLIENS_SUCCESS';
export const FETCH_AUTEURLIENS_FAILURE = 'FETCH_AUTEURLIENS_FAILURE';

export const SAVE_DATES_REQUEST  = 'SAVE_DATES_REQUEST';
export const SAVE_DATES_SUCCESS  = 'SAVE_DATES_SUCCESS';
export const SAVE_DATES_FAILURE  = 'SAVE_DATES_FAILURE';


export const SAVE_BIO_REQUEST = 'SAVE_BIO_REQUEST';
export const SAVE_BIO_SUCCESS = 'SAVE_BIO_SUCCESS';
export const SAVE_BIO_FAILURE = 'SAVE_BIO_FAILURE';

export const SAVE_BIBLIO_REQUEST = 'SAVE_BIBLIO_REQUEST';
export const SAVE_BIBLIO_SUCCESS = 'SAVE_BIBLIO_SUCCESS';
export const SAVE_BIBLIO_FAILURE = 'SAVE_BIBLIO_FAILURE';

export const SAVE_AUTEURLIEN_REQUEST = 'SAVE_AUTEURLIEN_REQUEST';
export const SAVE_AUTEURLIEN_SUCCESS = 'SAVE_AUTEURLIEN_SUCCESS';
export const SAVE_AUTEURLIEN_FAILURE = 'SAVE_AUTEURLIEN_FAILURE';

export const HIDE_AUTEURLIEN_REQUEST = 'HIDE_AUTEURLIEN_REQUEST';
export const HIDE_AUTEURLIEN_SUCCESS = 'HIDE_AUTEURLIEN_SUCCESS';
export const HIDE_AUTEURLIEN_FAILURE = 'HIDE_AUTEURLIEN_FAILURE';

const requestAuteurLivres = function(){
    return {
        'type': REQUEST_AUTEURLIVRES
    }
}

const fetchAuteurLivresSuccess = function(res){
    return {
        'type': FETCH_AUTEURLIVRES_SUCCESS,
        'payload' : {'lastRefreshed' : new Date(), 'livres' : res.data}
    }
}

const fetchAuteurLivresFailure = function(error){
    return {
        'type' : FETCH_AUTEURLIVRES_FAILURE,
        'payload' : error
    }
}

export function fetchAuteurLivres(id){
    return function(dispatch){
        dispatch(requestAuteurLivres());
        return auteurapi.getAuteurLivres(id)
         .then((res)=>{
            dispatch(fetchAuteurLivresSuccess(res))
        })
         .fail((error)=>{
            dispatch(fetchAuteurLivresFailure(error));
         })
    }
}

const requestBioBiblio = function(){
    return {
        'type': REQUEST_BIOBIBLIO
    }
}

const fetchBioBiblioFailure = function(error){
    return {
        'type': FETCH_BIOBIBLIO_FAILURE,
        'payload' : error
    }
}

const fetchBioBiblioSuccess = function(data){
    return {
        'type': FETCH_BIOBIBLIO_SUCCESS,
        'payload' : data
    }
}

export function fetchBioBiblio(id){
    return function(dispatch){
        dispatch(requestBioBiblio());
        return auteurapi.getBioBiblio(id)
            .then((data)=>{
                dispatch(fetchBioBiblioSuccess(data));
            })
            .fail((error)=>{
                dispatch(fetchBioBiblioFailure(error));
            })
    }
}

const saveBioRequest = function(){
    return {
        'type' : SAVE_BIO_REQUEST
    }
}

const saveBiblioRequest = function(){
    return {
        'type' : SAVE_BIBLIO_REQUEST
    }
}


const saveBioFailure = function(error){
    return {
        'type' : SAVE_BIO_FAILURE,
        'payload' : error
    }
}

const saveBiblioFailure = function(error){
    return {
        'type' : SAVE_BIBLIO_FAILURE,
        'payload' : error
    }
}

const saveBiblioSuccess = function(html){
    return {
        'type' : SAVE_BIBLIO_SUCCESS,
        'payload' : html
    }
}

const saveBioSuccess = function(html){
    return {
        'type' : SAVE_BIO_SUCCESS,
        'payload' : html
    }
}


export function saveBiblio(aid,html){
    return function(dispatch){
        dispatch(saveBiblioRequest());
        return auteurapi.saveBioBiblio(0,aid,html)
            .then((data)=>{
                dispatch(saveBiblioSuccess(data));
            })
            .fail((error)=>{
                dispatch(saveBiblioFailure(error));
            })
    }
}

export function saveBio(aid,html){
    return function(dispatch){
        dispatch(saveBioRequest());
        return auteurapi.saveBioBiblio(1,aid,html)
            .then((data)=>{
                dispatch(saveBioSuccess(data));
            })
            .fail((error)=>{
                dispatch(saveBioFailure(error));
            })
    }
}

const requestAuteurLiens = function(){
    return {
        'type' : REQUEST_AUTEURLIENS
    }
}

const fetchAuteurLiensFailure = function(error){
    return{
        'type' : FETCH_AUTEURLIENS_FAILURE,
        'payload' : error
    }
}

const fetchAuteurLiensSuccess = function(liens){
    return {
        'type' : FETCH_AUTEURLIENS_SUCCESS,
        'payload' : liens
    }
}

export function fetchAuteurLiens(id) {
    return function(dispatch){
        dispatch(requestAuteurLiens());
        return auteurapi.getAuteurLiens(id)
         .then((data)=>{
            dispatch(fetchAuteurLiensSuccess(data.data))
         })
         .fail((error)=>{
            dispatch(fetchAuteurLiensFailure(error))
         })
    }
}

const saveAuteurLienRequest = function(lien){
    return {
        'type' : SAVE_AUTEURLIEN_REQUEST ,
        'payload' : lien
    }
}

const saveAuteurLienSuccess = function(lien){
    return {
        'type' : SAVE_AUTEURLIEN_SUCCESS,
        'payload': lien
    }
}

const saveAuteurLienFailure = function(error){
    return {
        'type' : SAVE_AUTEURLIEN_FAILURE,
        'payload': error
    }
}

export function saveAuteurLien(aid, lien){
    return function(dispatch){
        dispatch(saveAuteurLienRequest());
        return auteurapi.saveAuteurLien(aid,lien)
            .then((lien)=>{
                dispatch(saveAuteurLienSuccess(lien));
            })
            .fail((error)=>{
                dispatch(saveAuteurLienFailure(error))
            })
    }
}

const hideAuteurLienRequest = function(){
    return {
        'type' : HIDE_AUTEURLIEN_REQUEST 
    }
}

const hideAuteurLienSuccess = function(id){
    return {
        'type' : HIDE_AUTEURLIEN_SUCCESS,
        'payload': id
    }
}

const hideAuteurLienFailure = function(error){
    return {
        'type' : HIDE_AUTEURLIEN_FAILURE,
        'payload': error
    }
}

export function hideAuteurLien(aid,id){
    return function(dispatch){
        dispatch(hideAuteurLienRequest());
        return auteurapi.hideAuteurLien(aid,id)
            .then(()=>{
                dispatch(hideAuteurLienSuccess(id));
            })
            .fail((error)=>{
                dispatch(hideAuteurLienFailure(error))
            })
    }
}

const saveDatesRequest = () => ({
    'type' : SAVE_DATES_REQUEST
})

const saveDatesSuccess = (d1,d2) => ({
    'type' : SAVE_DATES_SUCCESS,
    'payload' : {'date1' : d1, 'date2' : d2}
}) 

const saveDatesFailure = (error) => ({
    'type' : SAVE_DATES_FAILURE,
    'payload' : error
}) 

export function saveDates(aid,d1,d2){
    return function(dispatch){
        dispatch(saveDatesRequest());
        return auteurapi.saveDates(aid,d1,d2)
         .then(()=>{
            dispatch(saveDatesSuccess(d1,d2));
         })
         .fail((error)=>{
            dispatch(saveDatesFailure(error));
         });
    }
}




// WEBPACK FOOTER //
// ./auteur/actions/auteur.js